export default {"src":"/_next/static/media/nf.ba4a78f6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};